import { FC, useEffect } from 'react';
import { useRideOverviewStore } from '@rideiq/rides/stores/rideOverviewStore';

import { RideOverview } from '../../../features/RideOverview';

import { useRideOverviewTabs } from './useRideOverviewTabs';

interface RideOverviewForAddRideProps {
  isSeries?: boolean;
  formData?: Partial<RideFormData> | null;
  getEstimatedFare?: (fare: string | undefined) => void;
}

export const RideOverviewForAddRide: FC<RideOverviewForAddRideProps> = ({ isSeries, formData, getEstimatedFare }) => {
  const { tabs, currentTab, setCurrentTab, baseHeight, errorText } = useRideOverviewTabs(isSeries, formData);
  const { rideOverview } = useRideOverviewStore();

  useEffect(() => {
    getEstimatedFare && getEstimatedFare(rideOverview.rideInfo?.estimatedFare);
  }, [rideOverview]);

  return (
    <RideOverview
      currentTab={currentTab}
      onTabClick={setCurrentTab}
      tabs={tabs}
      baseHeight={baseHeight}
      errorText={errorText}
    />
  );
};
